import { createContext } from 'react'

import { UserAppConfigStore } from '../stores/UserAppConfigStore/UserAppConfigStore'

export const UserAppConfigStoreContext = createContext<UserAppConfigStore | null>(
   null
)
